import React, { useEffect, useState, useContext } from 'react'
import GeneralPopup from '../shared/GeneralPopup'
import { auth } from '../services/auth';
import { WalletIcon } from '@heroicons/react/24/solid'
import CoinbaseIcon from '../../src/assets/images/Coinbase-icon-symbol-1.png'
import { useNavigate } from 'react-router-dom';
import Loader from '../shared/Loader';
import SocialLogo from '../shared/SocialLogo';
import YoutubeDetails from '../components/social/partial/YoutubeDetails';
import { Helmet } from 'react-helmet';
import { deleteAllCartItems, deleteCartItem } from '../services/cart';
import styles from "../css/cart.module.css"
import AppContext from '../contexts/appContext';
import useCart from '../hooks/useCart';

export default function Cart() {
	const { setCart } = useContext(AppContext);

	const [cartData, setCartData] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [products, setProducts] = useState([]);
	const [hasError, setHasError] = useState(false);
	const [config, setConfig] = useState(null);
	const [cartMemory, setCartMemory] = useState([]);
	const [metaRow, setMetaRow] = useState([]);
	const [showPopup, setPopup] = useState(false);

	const user = auth().getUser();
	const token = auth().getToken();
	const navigate = useNavigate();
	const { mainCart, error, isLoading } = useCart(refresh);

	const itemConfig = {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${token}`
		},
	}

	useEffect(() => {
		setConfig({
			headers: { Authorization: `Bearer ${auth().getToken()}` }
		});
	}, []);

	useEffect(() => {
		if (user) {
			setCartData(mainCart);
		} else {
			setCartMemory(mainCart);
		}
		setCart(mainCart);
	}, [mainCart, refresh, user]);

	const subCategoryService = (subCategoryService) => {
		switch (subCategoryService) {
			case "InstaDefault":
				return "Insta";
			case "InstaImages":
			case "InstaComments":
			case "InstaCustomComments":
			case "InstaVideo":
				return "Insta";
			case "FacebookPage":
			case "FacebookPosts":
			case "FacebookVideo":
			case "FacebookComment":
			case "FacebookCustomComment":
			case "FacebookProfile":
			case "FacebookDefault":
				return "Facebook";
			case "TwitterFollow":
				return "TwitterFollow";
			case "TwitterPost":
				return "Twitter";
			case "YoutubeVideo":
			case "YoutubeCustomComments":
			case "YoutubeChannel":
				return "Youtube";
			case "SoundCloudTrack":
			case "SoundCloudArtist":
				return "SoundCloud";
			case "TikTokProfile":
				return "TikTok";
			case "TikTokPost":
			case "TikTokComments":
			case "TikTokCustomComments":
				return "TikTok";
			default:
				break;
		}
	}

	const handleRefresh = (value) => {
		if (value) {
			setRefresh(!refresh);
		}
	}

	const emptyCart = async () => {
		if (user) {
			await deleteAllCartItems(user, config)
				.then((response) => {
					if (response.status === 200) {
						setCart([]);
						setHasError(false);
						handleRefresh(!refresh);
					}
				})
		} else {
			localStorage.removeItem("cart");
			setCartMemory([]);
			setCart([]);
		}
	}

	const removeItem = (event) => {
		return deleteCartItem(itemConfig, event)
			.then((response) => {
				if (response.ok) {
					handleRefresh(true);
				}
				return response.json();
			})
	}

	const removeItemMemory = (id) => {
		let updatedCartMemory = [...cartMemory]
		updatedCartMemory.splice(id, 1)
		setCartMemory(updatedCartMemory);
		setCart(updatedCartMemory);
		localStorage.setItem("cart", JSON.stringify(updatedCartMemory))
	}

	const toCheckout = async (value) => {
		if (!cartData.length && !cartMemory.length) {
			// TODO: Display error messages/labels
			return;
		} else {
			placeOrder();
			if (user) {
				localStorage.setItem("email", JSON.stringify(user?.email));
			}
			localStorage.setItem("checkoutType", JSON.stringify(value));
		}
	}

	useEffect(() => {
		if (products.length) {
			localStorage.setItem("products", JSON.stringify(products));
			const checkoutType = JSON.parse(localStorage.getItem("checkoutType"))
			navigate(`/checkout/${checkoutType}`);
		}
	}, [products]);

	const placeOrder = () => {
		let newProducts = [];
		if (user) {
			cartData && cartData.map((cartItem, idx) => (
				newProducts = newProducts.concat({
					linkToPage: cartItem.linkToPage,
					itemComment: cartItem.itemComment,
					PaymentComment: "", //This should be empty ?!
					quantity: cartItem?.menuItem?.quantity,
					itemId: cartItem.itemId, //service ID
					item: [cartItem.menuItem], //Whole menu
					img64: cartItem.img64, //FETCH FROM SERVER ?
					menuItemId: cartItem.menuItemId, //menuItem ID
					selectedSubCategory: cartItem.menuItem.subcategory,
					imgOriginalLink: cartItem.imgOriginalLink,
				})
			))
			setProducts(products => ([...products, ...newProducts]));
			localStorage.setItem("products", JSON.stringify(products));
		}
		else {
			localStorage.setItem("products", JSON.stringify(cartMemory))
			navigate(`/checkout/1`);
		}
	}

	const paymentMethodPopup = () => {
		if (!cartData.length && !cartMemory.length) {
			// TODO: Display error messages/labels
			return;
		}
		togglePopup();
	}

	const togglePopup = (value) => {
		setPopup(!showPopup);
	}

	const showMore = (rowId) => {
		let oldRows = [...metaRow];
		let tempRow = oldRows.indexOf(rowId);
		if (tempRow > -1) {
			oldRows.splice(tempRow, 1);
		} else {
			oldRows.push(rowId)
		}
		setMetaRow(oldRows);
	}

	let localCart = null;

	if (user != null && cartData?.length > 0) {
		localCart = (
			<>
				<div className="flex flex-row justify-center">
					<div className="grid grid-cols-8 gap-2 overflow-x-auto">
						<div className="font-semibold flex flex-row justify-center items-center">Service</div>
						<div className="font-semibold flex flex-row items-center">Product</div>
						<div className="font-semibold flex flex-row items-center">Link to Profile</div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center">Qty.</div>
						<div className="font-semibold flex flex-row items-center">Price</div>
						<div className="font-semibold flex flex-row justify-center items-center">Remove</div>
						<div></div>
						<div className="col-span-8"><hr /></div>
						{cartData?.map((item, idx) => (
							<React.Fragment key={item?.id}>
								<div key={idx} onClick={(item.img64 || subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube") ? () => showMore(item.id) : null}
									className={`grid grid-cols-8 col-span-8 gap-2 hover:bg-pink-100  transition-all
												 ${(item.img64 || subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube") ? " cursor-pointer " : ""}
												 ${(metaRow.indexOf(item.id) > -1) ? "bg-pink-100 " : ""}
												 `}>
									<div className={`flex flex-row justify-center items-center`}><SocialLogo serviceType={item?.menuItem?.subcategory?.nameOfService} /></div>
									<div className={`flex flex-row items-center font-semibold`}>{item.menuItem?.name}</div>
									<div className={`flex flex-row items-center col-span-2 break-all`}>
										{(subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "TikTok") ? (
											<>  <span className="text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md">
												{item?.img64 ?
													item?.menuItem !== null ? item.menuItem?.subcategory?.linkTo + "@" + item?.itemComment + "/video/" + item?.linkToPage : null
													: item?.menuItem !== null ? item.menuItem?.subcategory?.linkTo + "@" + item?.itemComment : null}
											</span>	</>
										) : null}
										{subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Twitter" ? (
											<>
												<div className="flex flex-col">
													<span className="text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl">
														<a href={item?.menuItem?.subcategory?.linkTo + (item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username + "/status/" + item?.linkToPage : null + "/status/" + item?.linkToPage)} target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
															{item?.menuItem?.subcategory?.linkTo + (item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username + "/status/" + item?.linkToPage : null + "/status/" + item?.linkToPage)}
														</a>
													</span>
													<span className="text-sm text-clip"> {item?.itemComment}</span>
												</div>
											</>
										) : null}
										{subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "TwitterFollow" ? (
											<>
												<div className="flex flex-col">
													<span className="text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl">
														<a href={item?.menuItem?.subcategory?.linkTo + (item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username : null)} target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
															{item?.menuItem?.subcategory?.linkTo + (item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username : null)}
														</a></span>
													<span className="text-sm text-clip"> {item?.itemComment}</span>
												</div>
											</>
										) : null}
										{(subCategoryService(item?.menuItem?.subcategory?.nameOfService) !== ("Twitter") &&
											subCategoryService(item?.menuItem?.subcategory?.nameOfService) !== ("TikTok") &&
											subCategoryService(item?.menuItem?.subcategory?.nameOfService) !== ("TwitterFollow") &&
											item?.menuItem?.subcategory?.linkTo != undefined) ?
											(<>
												<a target="_blank" href={item?.menuItem?.subcategory?.linkTo + item?.linkToPage} rel="noopener noreferrer" className="text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md hover:text-blue-500">
													{item?.menuItem?.subcategory?.linkTo + item?.linkToPage}

												</a>
											</>) : null
										}
									</div>
									<div className={`flex flex-row items-center`}>{item.quantity}</div>
									<div className={`flex flex-row items-center`}>{item.amountTotal} $</div>
									<div className={`text-center flex flex-row justify-center items-center`}><button id={item.id} className="font-semibold text-red-600 text-xl" onClick={() => removeItem(item.id)}>X</button></div>
									<div className={`text-center flex flex-row justify-center items-center max-w-sm col-span-1`}> {(item.img64 || subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube") ? "Show More " : ""}</div>
								</div>
								{metaRow.indexOf(item.id) > -1 && (item.img64 || subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube") ?
									<div key={"meta-" + idx} className="grid grid-cols-8 col-span-8 gap-0 transition-all ">
										{subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube" ? (
											<>
												<div className={`flex flex-row items-center`}></div>
												<div className={`flex flex-row items-center col-span-6 break-all border-b-2 border-r-2 rounded-b-xl border-l-2 py-4 p-2 h-40 min-h-full border-gray-350 bg-pink-50`}>
													<YoutubeDetails selectedSubCategory={item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[0] : null} youtube={item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1] : null}></YoutubeDetails>
												</div>
												<div className={`flex flex-row items-center`}></div>
											</>
										) : <>
											<div className={`flex flex-row items-center`}></div>
											<div className={`flex flex-row items-center justify-between col-span-6 break-all border-b-2 border-r-2 rounded-b-xl border-l-2 py-4 p-2 h-40 min-h-full border-gray-350 bg-pink-50`}>
												<div className={`flex flex-row justify-center text-center  items-center `}><img className={item.img64 ? "object-cover h-36 w-" : null} src={item.img64} alt={item.name}></img></div>
												<div className={`flex flex-row items-center text-center  font-semibold `}>{item.menuItem?.name}</div>
												<div className={`flex flex-row items-center text-center  break-all `}>Profile: <span className='font-semibold'>  {item.itemComment}</span> </div>
												<div className={`flex flex-row items-center text-center  break-all `}>Current Count: <span>/</span></div>
											</div>
										</>
										}
									</div> : null}
							</React.Fragment >
						))}
						<div className="font-semibold flex flex-row justify-center items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center">Total</div>
						<div className="font-semibold flex flex-row justify-center items-center">{cartData?.length > 0 && cartData?.map(prod => !prod?.discount ? prod?.amountTotal : prod?.discountPrice).reduce((a, b) => a + b).toFixed(2)} </div>
					</div>
				</div>
				<div className="py-10">
					<button className={`mt-2 px-10 py-1 ${styles.cartBtn}`} type="button" value="To Checkout" onClick={paymentMethodPopup}>To Checkout</button>
				</div>
			</>
		)
	}
	else if (!user && cartMemory?.length > 0) {
		localCart = (
			<>
				<div className="flex flex-row justify-center">
					<div className="grid grid-cols-9 gap-2   overflow-x-auto">
						<div className="font-semibold flex flex-row justify-center items-center">Service</div>
						<div className="font-semibold flex flex-row items-center">Product</div>
						<div className="font-semibold flex flex-row items-center col-span-3">Link to Profile</div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center ">Qty.</div>
						<div className="font-semibold flex flex-row items-center">Price</div>
						<div className="font-semibold flex flex-row justify-center items-center">Remove</div>
						<div className="col-span-8"><hr /></div>
						{cartMemory?.map((item, idx) => (
							<React.Fragment key={idx}>
								<div key={idx} onClick={(item.img64 || subCategoryService(item?.selectedSubCategory?.nameOfService) === "Youtube") ? () => showMore(idx) : null}
									className={`grid grid-cols-8 col-span-8 gap-2 hover:bg-pink-100  transition-all
						 ${(item.img64 || subCategoryService(item?.selectedSubCategory.nameOfService) === "Youtube") ? " cursor-pointer " : ""}
						 ${(metaRow.indexOf(idx) > -1) ? "bg-pink-100 " : ""}
						 `}>
									<div className={`flex flex-row justify-center items-center`}><SocialLogo serviceType={item?.selectedSubCategory.nameOfService} /></div>
									<div className={`flex flex-row items-center font-semibold`}>{item.selectedSubCategory.name}</div>
									<div className={`flex flex-row items-center col-span-3 break-all`}>
										{(subCategoryService(item?.selectedSubCategory.nameOfService) === "TikTok") ? (
											<><span className="text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl">
												{item?.img64 ?
													item?.selectedSubCategory !== null ? item.selectedSubCategory.linkTo + "@" + item?.itemComment + "/video/" + item?.linkToPage : null
													: item?.selectedSubCategory !== null ? item.selectedSubCategory.linkTo + "@" + item?.itemComment : null}
											</span>		</>
										) : null}
										{subCategoryService(item?.selectedSubCategory.nameOfService) === "Twitter" ? (
											<>
												<div className="flex flex-col">
													<span className="text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl"> {item.selectedSubCategory.linkTo}{item.selectedSubCategory.linkTo + item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username + "/status/" + item?.linkToPage : null + "/status/" + item?.linkToPage} </span>
													<span className="text-sm text-clip"> {item?.itemComment}</span>
												</div>
											</>
										) : null}
										{subCategoryService(item?.selectedSubCategory.nameOfService) === "TwitterFollow" ? (
											<>
												<div className="flex flex-col">
													<span className="text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl"> {item.selectedSubCategory.linkTo}{item.selectedSubCategory.linkTo + item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1].username : null} </span>
													<span className="text-sm text-clip"> {item?.itemComment}</span>
												</div>
											</>
										) : null}
										{(subCategoryService(item?.selectedSubCategory.nameOfService) !== ("Twitter") &&
											subCategoryService(item?.selectedSubCategory.nameOfService) !== ("TikTok")) ? item.selectedSubCategory.linkTo + item?.linkToPage : null
										}
									</div>
									<div className={`flex flex-row items-center`}>{item.item[0].quantity}</div>
									<div className={`flex flex-row items-center`}>{item.item[0].price}</div>
									<div className={`text-center flex flex-row justify-center items-center`}><button id={idx} className="font-semibold text-red-600 text-xl" onClick={(e) => removeItemMemory(e.target.id)}>X</button></div>
									<div className={`text-center flex flex-row justify-center items-center max-w-sm col-span-1`}> {(item.img64 || subCategoryService(item?.menuItem?.subcategory?.nameOfService) === "Youtube") ? "Show More " : ""}</div>
								</div>
								{metaRow.indexOf(idx) > -1 && (item.img64 || subCategoryService(item?.selectedSubCategory.nameOfService) === "Youtube") ?
									<div key={"meta-" + idx} className="grid grid-cols-8 col-span-8 gap-0 transition-all ">
										{subCategoryService(item?.selectedSubCategory.nameOfService) === "Youtube" ? (
											<>
												<div className={`flex flex-row items-center`}></div>
												<div className={`flex flex-row items-center col-span-5 break-all border-b-2 border-r-2 rounded-b-xl border-l-2 py-4 p-2 h-40 min-h-full border-gray-350 bg-pink-50`}>
													<YoutubeDetails selectedSubCategory={item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[0] : null} youtube={item?.imgOriginalLink != undefined ? JSON.parse(item?.imgOriginalLink)[1] : null}></YoutubeDetails>
												</div>
												<div className={`flex flex-row items-center`}></div>
											</>
										) : <>
											<div className={`flex flex-row items-center`}></div>
											<div className={`flex flex-row items-center justify-between col-span-6 break-all border-b-2 border-r-2 rounded-b-xl border-l-2 py-4 p-2 h-40 min-h-full border-gray-350 bg-pink-50`}>
												<div className={`flex flex-row justify-center text-center  items-center `}><img className={item.img64 ? "object-cover h-36 w-" : null} src={item.img64} alt={item.name}></img></div>
												<div className={`flex flex-row items-center text-center  font-semibold `}>{item.selectedSubCategory?.name}</div>
												<div className={`flex flex-row items-center text-center  break-all `}>Profile: <span className="font-semibold">  {item.itemComment}</span> </div>
												<div className={`flex flex-row items-center text-center  break-all `}>Current Count: <span>/</span></div>
											</div>
										</>
										}
									</div> : null}
							</React.Fragment >
						))}
						<div className="font-semibold flex flex-row justify-center items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center"></div>
						<div className="font-semibold flex flex-row items-center">Total</div>
						<div className="font-semibold flex flex-row justify-center items-center">{cartMemory?.length > 0 && cartMemory?.map(prod => !prod?.discount ? prod.item[0].price : prod?.discountPrice).reduce((a, b) => a + b).toFixed(2)}</div>
					</div>
				</div>
				<div className="py-10">
					<button className={`mt-2 px-10 py-1 ${styles.cartBtn}`} type="button" value="To Checkout" onClick={paymentMethodPopup}>To Checkout</button>
				</div>
			</>
		)
	} else {
		localCart = (<p className="text-center">Cart is empty!</p>)
	}
	return (
		<section className="my-10  flex flex-col justify-center items-center">
			<Helmet>
				<title>Dailysocialboost | Cart</title>
			</Helmet>
			<h2 className="text-center text-5xl font-bold my-16">Shopping Cart</h2>
			{(cartMemory?.length > 0 || cartData?.length > 0) ?
				<div className="flex flex-row mx-20 lg:mx-32 place-self-end"><button className={`mt-2 px-5 py-1 ${styles.cartBtn}`} onClick={() => emptyCart()}>Clear Cart</button></div>
				: null}
			{isLoading ?
				(<div className="my-5 mx-20 flex justify-center "> <Loader ></Loader> </div>)
				: hasError || error ? ((<p className="text-xl text-red-600">{`${error ? error : "Failed validating"}, please try again!`}</p>)) : (
					localCart
				)
			}
			{showPopup ?
				(
					<GeneralPopup title="Cart item preview" closePopup={togglePopup}>
						<div className="flex flex-row flex-wrap justify-evenly py-10">
							<button className={`flex flex-col px-10 py-10 w-64 items-center ${styles.cartWalletBtn}`} onClick={() => toCheckout(1)}>
								<span>
									<img className="h-8 w-8" src={CoinbaseIcon} alt="coinbase" />
								</span>
								<span>Coinbase</span>
							</button>
							{user ? (<button className={`flex flex-col px-10 py-10 w-64 items-center ${styles.cartWalletBtn}`} onClick={() => toCheckout(2)}>
								<span><WalletIcon className="h-8 w-8 text-blue-500" /></span>
								<span>Wallet</span>
							</button>) : null
							}
						</div>
					</GeneralPopup>
				) : null}
		</section>
	)
}
